import { Component, OnInit, SimpleChanges, OnChanges, Input } from '@angular/core';
import { OrderService } from 'src/app/_services/dispo/order.service';
import { CustomerBranchService } from 'src/app/_services/dispo/customer-branch.service';
import { AbstractControl, FormControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { TeamBaseService } from 'src/app/_services/dispo/team-base';
import { prepareEventListenerParameters } from '@angular/compiler/src/render3/view/template';
import { Router } from '@angular/router';
import { ActivatedRoute } from '@angular/router';
import { TeamAbsenceService } from 'src/app/_services/dispo/team-absence.service';
import { DateAdapter } from '@angular/material/core';
import moment from 'moment';

@Component({
  selector: 'app-team-absence-base',
  templateUrl: './team-absence-base.component.html',
  styleUrls: ['./team-absence-base.component.css']
})
export class TeamAbsenceBaseComponent implements OnInit {
  content: any;
  orderData: any;
  teamForm: any;
  orderTypeList: any;
  customerBranchList: any;
  orderList: any;
  isNew: Boolean = false;
  addNew: Boolean = false;
  customer_id: any;
  submitted = false;
  teamAbsenceData: any;
  timeControl = new FormControl();
  companyList: any;
  showModal = true;
  absenceId: any;
  teamBaseId: any;
  start: any;
  end: any;
  absenceList: any

  range = new FormGroup({
    start: new FormControl(),
    end: new FormControl()
  });

  constructor(
    private orderService: OrderService,
    private customerBranchService: CustomerBranchService,
    private fb: FormBuilder,
    private toastr: ToastrService,
    private teamBaseService: TeamBaseService,
    private teamAbsenceService: TeamAbsenceService,
    private router: Router,
    private route: ActivatedRoute, 
    private dateAdapter: DateAdapter<any>
  ) {
    this.dateAdapter.setLocale('de-DE');
  }

  ngOnInit(): void {
    //const startDate = new Date();
    //const endDate = new Date();
    //this.start = this.range.get('start').setValue(startDate);
    //this.end = this.range.get('end').setValue(endDate);

    this.teamBaseId = this.route.snapshot.parent.parent.params.id;
    this.absenceId = this.route.snapshot.params.id;
     //get current movie data

     
     this.teamAbsenceService.show(this.absenceId).subscribe( data => {
        console.log(data);
        this.teamAbsenceData = data.teamAbsence;
        this.absenceList = data.absenceType;
        if(data.teamAbsence == null) {this.isNew = true; this.teamForm = this.fb.group({team_base_id: this.teamBaseId, absence_type: 'blocked', start_date: null, end_date: null, note: null})} else {this.setForm(data.teamAbsence)};
        ;     //fill for
        //this.initCustomerBranches();
        //this.prepareChangeListener();
      },
      err => { this.content = JSON.parse(err.error).message;}
    );
    
  }

  get f(): { [key: string]: AbstractControl } {
    return this.teamForm.controls;
  }
  

  setForm(data) {
    this.teamForm = this.fb.group({
      id:                         data.id,
      team_base_id:               data.team_base_id || this.teamBaseId,
      absence_type:               'blocked',
      absence_type_id:            [data.absence_type_id,Validators.required],
      start_date:                 [data.start_date,Validators.required],
      end_date:                   [data.end_date,Validators.required],
      note:                       [data.note]  // Standardwert ist leer
    });
  }
  



 
 

   delete() {
    this.teamAbsenceService.delete(this.teamAbsenceData).subscribe(
      data => {
        this.toastr.success('Eintrag wurde unwiderruflich gelöscht', 'Eintrag gelöscht!');
      },
      err => {
        this.content = JSON.parse(err.error).message;
      }
    );
  }

  submit() {
    this.submitted = true;
    console.log(this.teamForm.value);
    if(this.teamForm.valid) { 
      if(this.isNew) {

        //store
        
        this.teamAbsenceService.store(this.teamForm.value).subscribe(
          data => {
            this.orderData = data;
            this.toastr.success('Daten gepeichert!');
          },
          err => {
            this.toastr.warning(err.error.error, 'Ein Fehler ist aufgetreten');
    
          }
        );
      } else {

        //update
        this.teamAbsenceService.update(this.teamForm.value).subscribe(
          data => {
            this.orderData = data;
            this.toastr.success('Daten gepeichert!');
          },
          err => {
            this.toastr.warning(err.error.message, 'Ein Fehler ist aufgetreten');

          }
        );
      };
    } else {
      this.toastr.warning('Formular nicht korrekt', 'Bitte prüfen');
    }

  }

  goBack() {
    this.router.navigate(['../../'],{ relativeTo: this.route }).then(() => {
      //window.location.reload();    
  });
    
    //this.router.navigateByUrl("/immo-details/' + id + '/immo-base");
  }

  onDialogClick(event: UIEvent) {
    // Capture click on dialog and prevent it from bubbling to the modal background.
    event.stopPropagation();
    event.cancelBubble = true;
  }

}
